import axios from 'axios';

/** config **/
axios.interceptors.request.use(async function (config) {
    if (config['token']) {
        config.headers['Authorization'] = "Bearer " + config['token'];
        delete config['token'];
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    if(response.config && response.config.fnResMiddleware){
        response.config.fnResMiddleware(response);
    }

    return response;
}, async function (error) {
    const originalRequest = error.config;

    // blob 요청 시 JSON 에러 처리
    if (error.response && error.response.data instanceof Blob) {
        const contentType = error.response.headers["content-type"];
        if (contentType && contentType.includes("application/json")) {
            try {
                const errorText = await error.response.data.text();
                const parsedError = JSON.parse(errorText);

                error = parsedError?.error || parsedError;
            } catch (parseError) {
                console.error("JSON 파싱 실패:", parseError);
            }
        }
    }

    // 토큰 만료 상태 코드가 401이고, 이전에 재시도한 요청이 아닐 경우
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true; // 중복 요청 방지

        // 서버가 새로운 access token을 응답 헤더에서 제공하는 경우
        const newAccessToken = error.response.headers['x-access-token'];
        if (newAccessToken) {
            // 새로운 토큰으로 요청 헤더 업데이트
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

            // 원래 요청을 새로운 토큰으로 다시 시도
            return axios(originalRequest);
        }
    }

    return Promise.reject(error);
});

export default axios;
